import React from 'react'
import { cn } from './cn'

// Tailwind replacement for CoreUI's <CCard>/<CCardHeader>/<CCardBody>.
export const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'tw-flex tw-flex-col tw-rounded tw-border tw-border-gray-200',
      'tw-bg-white tw-shadow-sm',
      className
    )}
    {...props}
  />
))
Card.displayName = 'Card'

export const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'tw-border-b tw-border-gray-200 tw-px-4 tw-py-3',
      'tw-font-semibold tw-text-gray-900',
      className
    )}
    {...props}
  />
))
CardHeader.displayName = 'CardHeader'

export const CardBody = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('tw-flex-1 tw-p-4', className)} {...props} />
))
CardBody.displayName = 'CardBody'
